import { generateButtonToggle } from '@js/modules/floatingButton/index';
import { kvControlHeight } from '@js/modules/kvControlHeight';

kvControlHeight();
window.addEventListener('resize', kvControlHeight);

const buttonToggle = generateButtonToggle('.top-round-button--floating', '.top-contents', '.footer');
window.addEventListener('load', buttonToggle);
window.addEventListener('scroll', buttonToggle);
